import React, {useEffect, useState} from 'react';
import {ArticleList, MainContent} from "../style";
import {SearchInput} from "../../Child/SupplierMangement/style";
import {
    getData,
    remove_item_of_arr_with_slug, setTitle
} from "../../../../assets/scripts/GeneralFunctions";
import {MAIN_URL, MAIN_URL_IMAGE} from "../../../../assets/scripts/GeneralVariables";
import {Images} from "../../../../assets/scripts/Images";
import {Link} from "react-router-dom";
import Swal from "sweetalert2";
import Skeleton from 'react-loading-skeleton'
import Flags from "../../../utils/Flags";

function Articles(props) {
    const [inputs, setInputs] = useState({
        search_value: '', posts: [NaN, NaN, NaN, NaN], locale: 'fa',
        companies: [],
    })
    const [is_all_items_load, setAllLoad] = useState(true)
    const [data, setObject] = useState({
        'offset': 0,
        'limit': 30,
    })
    useEffect(async () => {
        setTitle('آذر فولاد امین | اخبار')
        let api_result = await getData(MAIN_URL, `blog-management/posts/${inputs?.locale}`, 'get', data, true, false);
        if (api_result?.status === 200) {
            setInputs(prevState => ({
                ...prevState,
                posts: api_result?.data?.posts,
                companies : api_result?.data?.about_companies,
            }))
        }
    }, []);

    const searchHandler = async (e) => {
        let object = {};
        object = data;
        object['search'] = e.target.value
        setInputs(prevState => ({
            ...prevState,
            search_value: e.target.value,
            posts: [NaN, NaN, NaN, NaN],
        }))
        let api_result = await getData(MAIN_URL, `blog-management/posts/${inputs?.locale}`, 'get', object, true, false);
        if (api_result?.status === 200) {
            let data = api_result?.data
            setInputs(prevState => ({
                ...prevState,
                posts: data?.posts
            }))
            setObject(object)
        }
    }

    // lazy load
    const getTableDataLazyLoad = async (obj_data) => {
        if (parseFloat(obj_data.target.offsetHeight + obj_data.target.scrollTop) == parseFloat(obj_data.target.scrollHeight)) {
            if (inputs?.items?.length % 30 === 0 && is_all_items_load === true) {
                let object = {};
                object = data;
                object['offset'] = inputs?.posts?.length
                let moreData = await getData(MAIN_URL, `blog-management/posts/${inputs?.locale}`, 'get', object, true, true);
                if (moreData) {
                    setObject(object)
                    setInputs(prevState => ({...prevState, posts: inputs?.posts.concat(moreData.data?.posts)}))
                    if (moreData.data?.posts?.length < 30) {
                        setAllLoad({is_all_items_load: false})
                    }
                }
            }
        }
    }

    const handleLanguage = async (locale) => {
        setInputs(prevState => ({...prevState, posts: [NaN, NaN, NaN, NaN]}))
        let api_result = await getData(MAIN_URL, `blog-management/posts/${locale?.value}`, 'get', data, true, false);
        if (api_result?.status === 200) {
            setInputs(prevState => ({
                ...prevState,
                posts: api_result?.data?.posts,
                locale: locale?.value
            }))
        }
    }

    const removeItem = async (slug) => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false
        })
        swalWithBootstrapButtons.fire({
            title: 'آیا مطمئن هستید؟',
            text: "میخواهید این مورد را حذف کنید",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'بله حذف کن',
            cancelButtonText: 'نه حذف نشود',
            reverseButtons: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                let remove_result = await getData(MAIN_URL, `blog-management/posts/remove/${slug}`, 'post', {}, true, true);
                if (remove_result?.status === 200) {
                    swalWithBootstrapButtons.fire(
                        'حذف شد!',
                        'با موفقیت حذف شد',
                        'success'
                    )
                    let arr = inputs?.posts;
                    let new_arr = remove_item_of_arr_with_slug(arr, slug)
                    setInputs(prevState => ({...prevState, posts: new_arr}))
                }
            }
        })
    }


    return (
        <MainContent>
            <div className='row'>
                <div className="col-12 d-flex flex-column flex-md-row align-items-center justify-content-between mb-3">
                    <h6 className='text-red fw-bold'>مقالات</h6>
                    <div className="d-flex flex-wrap flex-md-nowrap">
                        <SearchInput className='mb-3'>
                            <span className='icon-Search dv-search-icon'/>
                            <input type="search" value={inputs?.search_value} onChange={searchHandler}
                                   placeholder='جستجو'/>
                        </SearchInput>
                        <div className="d-flex flex-column flex-sm-row w-100 position-relative">
                            <Link to={{pathname: '/new_articles', locale: inputs?.locale, companies : inputs?.companies}} className='add-new-btn ms-3'>
                                <span className="icon-add_paper"/>
                                <span>افزودن مقاله جدید</span>
                            </Link>
                            <Flags handleLanguage={handleLanguage}/>
                        </div>
                    </div>
                </div>
                <div className="col-12 mb-3 afa-lazyload" onScroll={getTableDataLazyLoad}>
                    {
                        inputs?.posts?.length > 0 ?
                            !inputs?.posts[0] ?
                                inputs?.posts?.map((row, index) => (
                                    <>
                                        <Skeleton borderRadius={8} height={55} className='mb-3'/>
                                    </>
                                )) :
                                inputs?.posts?.map((row, index) => (
                                    <ArticleList className='row align-items-center' key={index}>
                                        <div
                                            className="col-12 col-sm-6 col-lg-2 mb-3 d-flex align-items-center justify-content-around">
                                        <span className="icon-Delete dv-icon-delete pl-2 my-2"
                                              onClick={() => removeItem(row.slug)}></span>
                                            <div className="afa-article-img">
                                                <img
                                                    src={row?.image ? `${MAIN_URL_IMAGE}${row?.image}` : Images?.article.default}
                                                    className='img-fluid' alt={row?.slug}/>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-9 mb-3">
                                            <div className="d-flex flex-column align-items-stretch">
                                                <h6 className='afa-header-article mb-3'>{row?.title}</h6>
                                                <p className='afa-text-p'>{row?.description}</p>
                                            </div>
                                        </div>
                                        <div
                                            className="col-12 col-sm-6 col-lg-1 mb-3 d-flex align-items-center justify-content-center">
                                            <Link className={'text link-color'}
                                                  to={`/manage-blog/${row?.slug}`}>ویرایش<span
                                                className="icon-cheveron-left"></span></Link>
                                        </div>
                                    </ArticleList>
                                )) : <p className='text-center'>آیتمی وجود ندارد</p>
                    }
                </div>
            </div>
        </MainContent>
    );
}

export default Articles;